export default function usePageViews(loc) {
	
	if(loc !== sessionStorage.loc) {
		sessionStorage.setItem('loc',loc);
		window.analytics.page(loc);
	}
}